module.exports = __webpack_public_path__ + "img/icon8.9616b084.9616b084.svg";